import App from "./components/App.svelte";

const dev = !!import.meta.hot;

const app = new App({
  target: document.querySelector("div#graphic-content"),
  hydrate: !dev
});

if (dev) {
  import.meta.hot.dispose(() => {
    app.$destroy();
  });
  import.meta.hot.accept();
}

export default app;
